import { CatalogueWindowDays, DetailPageNavState, WINDOW_TO_DAYS } from './catalogueUtils'

const WINDOW_DAYS: readonly number[] = Object.values(WINDOW_TO_DAYS)

const isOptionalNumberOrNull = (value: unknown): value is number | null | undefined => value === undefined || value === null || typeof value === 'number'

const isOptionalWindowDays = (value: unknown): value is CatalogueWindowDays | undefined =>
  value === undefined || (typeof value === 'number' && WINDOW_DAYS.includes(value))

// Router `state` is whatever the previous page pushed (or a stale history entry), so
// it is checked field by field rather than cast.
export function isDetailPageNavState(value: unknown): value is DetailPageNavState {
  if (typeof value !== 'object' || value === null) return false
  const state = value as Record<string, unknown>
  return (
    typeof state.catalogueBackSearch === 'string' &&
    isOptionalNumberOrNull(state.deltaGames) &&
    isOptionalNumberOrNull(state.cohortSize) &&
    isOptionalWindowDays(state.deltaWindowDays)
  )
}

export function readDetailPageNavState(value: unknown): DetailPageNavState | undefined {
  return isDetailPageNavState(value) ? value : undefined
}
